import { z } from "zod/v4";

export const CommentSchema = z.object({
    fen: z.string(),
    comment: z.string(),
});

export type Comment = z.infer<typeof CommentSchema>;

export type CommentsMap = Record<string, Comment[]>;
